import React, { useState, useEffect } from "react";
import MatrixTree from "../../components/MatrixTree/MatrixTree";
import { PLAN1_PKG_COUNT } from "../../config/config";

export default function StarTeam({ userId, contracts, maxLevels }) {
  const [directCount, setDirectCount] = useState(0);
  const [levelCounts, setLevelCounts] = useState([]);

  useEffect(() => {
    if (userId && contracts) loadData();
    // eslint-disable-next-line
  }, [userId, contracts]);

  async function loadData() {
    try {
      const [count, counts] = await Promise.all([
        contracts.data.getUserDirectCount(userId),
        contracts.plan1.getMatrixLevelCounts(userId),
      ]);
      setDirectCount(count.toNumber());
      setLevelCounts(counts.map((c) => c.toNumber()));
    } catch (err) {
      console.error("StarTeam:", err);
    }
  }

  const totalTeam = levelCounts.reduce((s, c) => s + c, 0);

  return (
    <div className="plan-team-section">
      <div className="plan-team-stats-row">
        <div className="plan-team-stat">
          <span className="plan-team-stat-value">{directCount}</span>
          <span className="plan-team-stat-label">Direct Refs</span>
        </div>
        <div className="plan-team-stat">
          <span className="plan-team-stat-value">{totalTeam}</span>
          <span className="plan-team-stat-label">Total Team</span>
        </div>
      </div>

      <MatrixTree
        userId={userId}
        planContract={contracts.plan1}
        dataContract={contracts.data}
        maxLevels={maxLevels}
        showUplines={false}
        pkgCount={PLAN1_PKG_COUNT}
      />
    </div>
  );
}
